/**
 * Store data in localStorage
 * @param {string} key - Storage key
 * @param {any} value - Value to store
 */
export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error saving to localStorage:", error);
  }
};

/**
 * Retrieve stored data from localStorage
 * @param {string} key - Storage key
 * @returns {any | null} - Parsed value or null
 */
export const getLocalStorage = key => {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error("Error reading from localStorage:", error);
    return null;
  }
};

/**
 * Remove an item from localStorage
 * @param {string} key - Storage key
 */
export const removeLocalStorage = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing from localStorage:", error);
  }
};

/**
 * Store data in sessionStorage
 * @param {string} key - Storage key
 * @param {any} value - Value to store
 */
export const setSessionStorage = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error saving to sessionStorage:", error);
  }
};

/**
 * Retrieve stored data from sessionStorage
 * @param {string} key - Storage key
 * @returns {any | null} - Parsed value or null
 */
export const getSessionStorage = key => {
  try {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error("Error reading from sessionStorage:", error);
    return null;
  }
};

/**
 * Remove an item from sessionStorage
 * @param {string} key - Storage key
 */
export const removeSessionStorage = key => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing from sessionStorage:", error);
  }
};
